import z from "zod";

import { createCall, spellbook } from "@sdk/spellbook";

import { withAccountAuthHeaders } from "./apiHelpers";

const endpoint = spellbook("/tasks/{id}/siders/prospects").GET();

export const SiderSchema = endpoint.res.shape.siders.unwrap().element;
export type SiderProspect = z.infer<typeof SiderSchema>;

export async function getSidersProspects({ taskId }: { taskId: typeof endpoint.types.P.id }) {
    const call = createCall(endpoint, (r) => fetch(withAccountAuthHeaders(r)));

    return await call({
        params: {
            id: taskId,
        },
    });
}
